import React, { useState } from 'react'
import { AddFoodPricePeriodComponent } from '../Components/FoodPricePeriod/AddFoodPricePeriodComponent';
import { AllFoodPricePeriodComponent } from '../Components/FoodPricePeriod/AllFoodPricePeriodComponent';
import { EditFoodPricePeriodComponent } from '../Components/FoodPricePeriod/EditFoodPricePeriodComponent';
import { FoodPeriodCategoryComponent } from '../Components/Category/FoodPeriodCategoryComponent';
import { EditFoodPricesComponent } from '../Components/FoodPricePeriod/EditFoodPricesComponent';
// ======================================================================
export const FoodPricePeriod = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('Category');
    const [categoryId, setCategoryId] = useState();
    const [categoryTitle, setCategoryTitle] = useState();

    const [currentPage, setCurrentPage] = useState(1);
    const [version, setVersion] = useState(0);
    const [id, setId] = useState(0);
    // ======================================================================
    return (
        <>
            {view === "Category" ?
                <FoodPeriodCategoryComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    onClickItems={(id, title) => {
                        setCategoryId(id);
                        setCategoryTitle(title);
                        setView("All");
                    }}
                />
                : <></>}

            {view == "All" ?
                <AllFoodPricePeriodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    categoryId={categoryId}
                    categoryTitle={categoryTitle}
                    version={version}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    onAddClick={() => setView("Add")}
                    onEdit={(id) => { setId(id); setView("Edit") }}
                    onRowDeleted={() => { setVersion(version + 1); }}
                    onPricesClick={(id) => { setId(id); setView("Prices") }}
                    onBackClick={()=> setView("Category")}
                    /> : <></>}
            {view === "Add" ?
                <AddFoodPricePeriodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    categoryId={categoryId}
                    categoryTitle={categoryTitle}
                    rowInserted={() => {
                        setView("All"); if (currentPage != 1)
                            setCurrentPage(1);
                        else
                            setVersion(version + 1);
                    }}
                    cancelInsert={() => { setView("All"); }} />
                : <></>}
            {view === "Edit" ?
                <EditFoodPricePeriodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    id={id}
                    rowUpdated={() => { setView("All"); setVersion(version + 1); }}
                    cancelEdit={() => { setView("All"); }} />
                :
                <></>}

            {view === "Prices" ?
                <>
                    <EditFoodPricesComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        foodPricePeriodId={id}
                        onCompleteEdit={() => { setView("All"); }}
                    />
                </>
                :
                <></>}
        </>
    )
}
